import requestApi from "./requestApi";
import { API_CONSTANT_MAP } from "./paths";

export const getAllProdutos = async () => {
  return requestApi.get(API_CONSTANT_MAP.produto);
};

export const getProdutoById = async (id: string | number) => {
  return requestApi.get(`${API_CONSTANT_MAP.produto}/${id}`);
};

export const saveProduto = async (payload: any) => {
  return requestApi.post(API_CONSTANT_MAP.produto, payload);
};

export const deleteProduto = async (id: string | number) => {
  return requestApi.delete(`${API_CONSTANT_MAP.produto}/${id}`);
};

export const ativarDesativarProduto = async (id: string | number, ativo: boolean) => {
  return requestApi.put(`${API_CONSTANT_MAP.produto}/${id}/ativo`, { ativo });
};

export const getProdutoHistorico = async (id: string | number) => {
  return requestApi.get(`${API_CONSTANT_MAP.produto}/${id}/historico`);
};
